class MessageBus {
  formattedReference = {};
}

const singleton = new MessageBus();
export default singleton;



// WEBPACK FOOTER //
// ./src/services/messageBus.js